// 画像の自動フォールバック。
//
// 背景: 管理画面の画像アップロードは Supabase Storage(product-images) に保存されるが、
// スプシに「ファイル名だけ」を入れるとサイトは /img/(FTP) を探しに行くため、
// FTPに実体が無いと画像が壊れる。
//
// 対策: /img/ の画像読み込みが失敗したら、自動で Supabase Storage から読み直す。
// これにより「管理画面でアップ → ファイル名をスプシに貼る → 同期」だけで画像が表示できる。
// ・読み込めなかった画像にだけ効くので、既に表示できている画像には一切影響しない。
// ・1画像につき1回だけ再試行する（無限ループ防止）。

const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL as string | undefined) || '';
const STORAGE_BASE = SUPABASE_URL
  ? `${SUPABASE_URL.replace(/\/$/, '')}/storage/v1/object/public/product-images/`
  : '';

export function installImageFallback(): void {
  if (typeof window === 'undefined' || !STORAGE_BASE) return;

  // 画像の error イベントはバブルしないため、キャプチャフェーズで拾う。
  window.addEventListener(
    'error',
    (e: Event) => {
      const el = e.target as HTMLImageElement | null;
      if (!el || el.tagName !== 'IMG') return;
      if (el.dataset.imgFallbackTried === '1') return;

      // 絶対URL/相対どちらでも末尾 /img/<filename> を抽出
      const m = el.src.match(/\/img\/([^/?#]+)$/);
      if (!m) return;

      el.dataset.imgFallbackTried = '1';
      el.src = STORAGE_BASE + m[1];
    },
    true,
  );
}
